import React, { useState } from 'react';
import { validateFunctionalForm } from '../../../utils';
import constant from '../../../constant';

const ShipTypeForm = ({ data, onSubmit, title }) => {
    const [state, setState] = useState({
        shipTypeName: { name: 'shipTypeName', value: data?.SHIP_TYPE_NAME || '', isRequired: true, error: '' },
        shipTypeCode: { name: 'shipTypeCode', value: data?.SHIP_TYPE_CODE || '', isRequired: false, error: '' },
        note: { name: 'note', value: data?.NOTE || '', isRequired: false, error: '' },
        isActive: { name: 'isActive', value: data?.IS_ACTIVE ?? true, isRequired: false }
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;

        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: val,
                error: prev[name].isRequired && !val ? 'This field is required' : ''
            }
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {};
            Object.keys(state).forEach(key => {
                model[key] = state[key].value;
            });
            if (data?.ID) model.id = data.ID;
            onSubmit(model);
        }
    };

    const handleReset = () => {
        const resetState = { ...state };
        Object.keys(resetState).forEach(key => {
            resetState[key].value = data?.[key.toUpperCase()] || (key === 'isActive' ? true : '');
            resetState[key].error = '';
        });
        setState(resetState);
    };

    return (
        <form onSubmit={handleSubmit}>
            {/* <h4 className="card-title mb-4">{title}</h4> */}
            <div className="row">
                {[
                    { label: 'Ship Type Name', name: 'shipTypeName', placeholder: 'Enter ship type name' },
                    { label: 'Ship Type Code', name: 'shipTypeCode', placeholder: 'Enter unique ship type code' }
                ].map(({ label, name, placeholder }) => (
                    <div className="col-md-6 mb-3" key={name}>
                        <label>{label} {state[name].isRequired && <span className='text-danger'> *</span>}</label>
                        <input
                            type="text"
                            name={state[name].name}
                            value={state[name].value}
                            onChange={handleChange}
                            placeholder={placeholder}
                            className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
                        />
                        {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
                    </div>
                ))}

                <div className="col-md-12 mb-3">
                    <label>Note</label>
                    <textarea
                        name={state.note.name}
                        value={state.note.value}
                        onChange={handleChange}
                        className="form-control"
                        rows="3"
                        placeholder="Enter any additional note"
                    />
                </div>

                <div className="col-md-4 form-check ms-2">
                    <input
                        type="checkbox"
                        name={state.isActive.name}
                        checked={state.isActive.value}
                        onChange={handleChange}
                        className="form-check-input"
                        id="isActive"
                    />
                    <label className="form-check-label" htmlFor="isActive">Active</label>
                </div>
            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Save</button>
                <a className="btn btn-danger text-white"  href={constant.Authedcomponent.listShipTypeMasterData.url}>Cancel</a>

            </div>
        </form>
    );
};

export default ShipTypeForm;
